import React, { useState, useEffect, useContext } from 'react';
import './LoginPagina.scss';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';

// componentes
import { Link, useHistory } from "react-router-dom";
import useIsMounted from 'ismounted';
import { Container } from 'react-bootstrap';
import { Alert, Button } from 'react-bootstrap';
import logo from './../../assets/midiaLocalLogo.png';


import LogoIcone from './../../icones/svg/logo2.svg';

function FazerLoginVigentes({

}){

    const [dados, alterarDados] = useState({
        usuario: null,
        senha: null
    });
    const [erros, alterarErros] = useState([]);
    const history = useHistory();
    const isMounted = useIsMounted();
    const dispatch = useDispatch();
    let [carregando, alterarCarregando] = useState(false);
    let [lembrar, alterarLembrar] = useState(false);
    // let loginVigentesReducer = useSelector(state => state.loginVigentesReducer);

    async function fazerLogin(){
        console.log("fazer login vigentes");

        // faz a requisição
        try{
            const { data } = await axios.post("/usuario/login/vigentes", dados);
            localStorage.setItem("login-vigentes", data.token);
            window.location.reload();
        }catch(response){
            alterarErros({
                "usuario": "Usuário ou senha inválido"
            });
        }
        
    }

    // retorna componente
    return <div className="container-fluid login-pagina">
        <div
            className="row d-md-flex" 
            // style={{
            //     background: `url(${backGroundImage})`,
            //     backgroundSize: `cover`
            // }}
        >
            <div md={3} className="logo">
                <img src={LogoIcone}/>
            </div>
            <div className="col-md-8 col-lg-6 m-auto">
                <div className="login d-flex align-items-center py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-9 col-lg-8 mx-auto">
                            <h3 className="login-heading mb-4">Acesso a vigentes!</h3>
                                <div className="form-label-group">
                                    <input 
                                        type="text" id="inputEmail"
                                        className={["form-control", (erros.email) ? 'input-erro' : ''].join(' ')} 
                                        placeholder="Endereço de email" 
                                        required autoFocus
                                        value={dados.usuario || ''}
                                        onChange={(e) => {
                                            dados.usuario = e.target.value;
                                            alterarDados({...dados});
                                        }}
                                        onKeyDown={e => {
                                            if(e.keyCode === 13) fazerLogin(e);
                                        }}
                                    />
                                    <label htmlFor="inputEmail">Usuário</label>
                                    { erros.usuario && 
                                        <Alert className="alerta-erro" dismissible onClose={() => alterarErros({})} variant="danger"><p>{erros.usuario}</p></Alert>
                                    }
                                    
                                </div>

                                <div className="form-label-group">
                                    <input 
                                        id="inputConfirmPassword"
                                        type="password"
                                        className={["form-control", (erros.senha) ? 'input-erro' : ''].join(' ')}
                                        placeholder="Senha" required 
                                        value={dados.senha || ''}
                                        onChange={(e) => {
                                            dados.senha = e.target.value;
                                            alterarDados({...dados});
                                        }}
                                        onKeyDown={e => {
                                            if(e.keyCode === 13) fazerLogin(e);
                                        }}
                                    />
                                    <label htmlFor="inputConfirmPassword">Senha</label>
                                    {(erros.senha) && 
                                        <Alert className="alerta-erro" dismissible onClose={() => alterarErros({})} variant="danger"><p>{erros.senha}</p></Alert>
                                    }
                                </div>

                                {/* <div className="custom-control custom-checkbox mb-3">
                                    <input type="checkbox" className="custom-control-input" id="customCheck1"/>
                                    <label className="custom-control-label" htmlFor="customCheck1">Lembrar</label>
                                </div> */}
                                <button 
                                    onClick={fazerLogin} 
                                    className="botao-entrar btn btn-lg btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2" 
                                    type="submit"
                                    disabled={carregando}
                                >
                                    {carregando && 
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    }
                                    {carregando ? ' Carregando' : 'Entrar' }
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="desenvolvido" ><p>Desenvolvido por</p> <img src={logo} /></div>
    </div>

}

export default FazerLoginVigentes;